module.exports = __webpack_public_path__ + "static/media/peacock-day.9bb72521.jpg";